import { InjectionToken } from '@angular/core';

export const MatSelectCountryLangToken = new InjectionToken<string>('MatSelectCountryLangToken');
